import "./SideDrawer.css";
import Box from "@material-ui/core/Box";
import ClearOutlinedIcon from "@material-ui/icons/ClearOutlined";
import React, { Component } from "react";
import MyAccountIcon from "../images/menu/my-account.svg";
import FAQIcon from "../images/menu/faq.svg";
import AlehIcon from "../images/menu/aleh.svg";
import SearchIcon from "../images/menu/search.svg";
import ProjectInfoIcon from "../images/menu/project-info.svg";
import LogoutIcon from "../images/menu/logout.svg";
import FacebookIcon from "../images/menu/facebook.svg";
import WhatsappIcon from "../images/menu/whatsapp.svg";
import {withRouter} from "react-router";

class StudentMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerClasses: "side-drawer",
      my_account_path: ""
    };  
    this.handleClickRoute = this.handleClickRoute.bind(this);
  };
 

  async componentWillMount()  {
    if (this.props.show) {
      this.state.drawerClasses = "side-drawer open";
    }
  };

  handleClickRoute = evt => {
    let type = evt.target.name;
    switch (type) {
      case "my account":
        this.props.history.push('/studentsignup');
        // console.log(this.props.userData);
        // this.props.history.push({ 
        //   pathname: '/studentsignup',
        //   state: { user: this.props.userData },
        // });
      break;
      case "my matches":
        this.props.history.push('/');
      break;
      case "common qa":
        this.props.history.push('/commonQA');
      break;
      case "info and terms":
        this.props.history.push('/terms');
      break;
      case "logout":
        this.props.history.push('/logout');
      break;
    }
};

  render() {
    return(
      <nav className={this.state.drawerClasses}>
      <div dir="rtl" className="toolbar">
        <nav className="toolbar_nav">
          <div className="spacer" />
          <div className="toolbar_logo">
            <text>בייביסיטר מיוחד במינו</text>
          </div>
      <div className="spacer" />
          <button className="close_icon_button" onClick={this.props.closeMenu}>
            <ClearOutlinedIcon
              className="close_icon"
              fontSize="medium"
            ></ClearOutlinedIcon>
          </button>
        </nav>
      </div>
      <ul>
        <li>
          <a name="my account" onClick={this.handleClickRoute} style={{cursor:"pointer", fontSize:"16px"}}>
            <span aria-label="my account">
                <button className="account_icon_button">
                  <img src={MyAccountIcon} width="35" height="35"/>
                </button>
            </span>
            החשבון שלי
          </a>
        </li>
        <li>
          <a name="my matches" onClick={this.handleClickRoute} style={{cursor:"pointer", fontSize:"16px"}}>
            <span aria-label="my matches">
                <button className="search_icon_button">
                  <img src={SearchIcon} width="35" height="35" />
                </button>
            </span>
            תוצאות חיפוש
          </a>
        </li>
        <li>
          <a name="common qa" onClick={this.handleClickRoute} style={{cursor:"pointer", fontSize:"16px"}}>
            <span aria-label="common qa">
                <button className="ques_icon_button">
                  <img src={FAQIcon} width="35" height="35"/>
                </button>
            </span>
            שאלות ותשובות נפוצות
          </a> 
        </li>
        <li>
          <a name="info and terms" onClick={this.handleClickRoute} style={{cursor:"pointer", fontSize:"16px"}}>
            <span aria-label="info and terms">
                <button className="temp_icon_button">
                  <img src={ProjectInfoIcon} width="35" height="35"/>
                </button>
            </span>
            מידע על הפרויקט ותנאי שימוש באפליקציה
          </a>
        </li>
        <li>
          <a href="https://api.whatsapp.com/send?phone=9720556876741&text=%20%D7%94%D7%99%D7%99,%20%D7%90%D7%A8%D7%A6%D7%94%20%D7%9C%D7%94%D7%A6%D7%98%D7%A8%D7%A3%20%D7%9C%D7%A7%D7%91%D7%95%D7%A6%D7%94%20%D7%91%D7%A2%D7%99%D7%A8..." style={{cursor:"pointer", fontSize:"16px"}}>
            <span aria-label="whatsapp">
                <button className="whatsapp_icon_button">
                  <img src={WhatsappIcon} width="35" height="35"/>
                </button>
            </span>
            יצירת קשר או הצטרפות לקבוצת וואטסאפ 
          </a>
        </li>
        <li>
          <a href="https://www.facebook.com/groups/372923226519288/" style={{cursor:"pointer", fontSize:"16px"}}>
            <span aria-label="facebook">
                <button className="facebook_icon_button">
                  <img src={FacebookIcon} width="35" height="35"/>
                </button>
            </span>
            הצטרפות לקבוצת פייסבוק
          </a>
        </li>
        <li>
          <a href="https://4u.adi-il.org/" style={{cursor:"pointer", fontSize:"16px"}}>
            <span aria-label="site">
              <button className="leaf_icon_button">
                <img src={AlehIcon} width="35" height="35"/>
              </button>
            </span>
            אתר עדי בשבילכם
          </a>
        </li>
        <Box m={2}/>
        <li>
          <a name="logout" onClick={this.handleClickRoute} style={{cursor:"pointer", fontSize:"16px"}}>
            <span aria-label="logout">
                <button className="off_icon_button">
                  <img src={LogoutIcon} width="35" height="35"/>
                </button>
            </span>
            התנתקות
          </a>
        </li>
      </ul>
    </nav>
    );
  }
}


export default withRouter(StudentMenu);